import { useMemo } from 'react';

import { GameMode } from '@/types/api.generated';

import { getWinningPicksAndToWin } from '../utils/betslip-utils';
import { useBetslipData } from './use-betslip-data';
import { useBetslipStore } from './use-betslip-store';

/** Returns the formatted multiplier string of the picks currently in the betslip (perfect multiplier or dynamic range). */
export const useEntryMultiplier = () => {
    const activeGameMode = useBetslipStore(state => state.activeGameMode);
    const { perfectBoostedMultiplier, perfectRegularMultiplier, dynamicMultipliers, dynamicBoostedMultiplier } =
        useBetslipData();
    const { highestMultiplier, lowestMultiplier } = getWinningPicksAndToWin(
        dynamicMultipliers.DYNAMIC,
        dynamicBoostedMultiplier
    );

    return useMemo(() => {
        if (activeGameMode === GameMode.Perfect) {
            const perfectMultiplier = perfectBoostedMultiplier || perfectRegularMultiplier;
            return perfectMultiplier ? `${perfectMultiplier}x` : '';
        }
        return `${lowestMultiplier}x-${highestMultiplier}x`;
    }, [activeGameMode, highestMultiplier, lowestMultiplier, perfectBoostedMultiplier, perfectRegularMultiplier]);
};
